// extracted by mini-css-extract-plugin
export var closeButton = "styles-module--closeButton--c7d54";
export var container = "styles-module--container--50a7c";
export var content = "styles-module--content--f8424";
export var desktop = "1340px";
export var giant = "2200px";
export var gradient = "styles-module--gradient--2901f";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var left = "styles-module--left--29112";
export var mobile = "400px";
export var open = "styles-module--open--84c42";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var topBar = "styles-module--topBar--133da";